import {setAppLoadedPromise} from "./loading";

export const INCREMENT_PAGE_COUNT = 'INCREMENT_PAGE_COUNT';
export const RESET_PAGE_COUNT = 'RESET_PAGE_COUNT';
export const CALCULATE_CHUNKED_ROW_KEYS = 'CALCULATE_CHUNKED_ROW_KEYS';


export function incrementPageCount() {
    return {
        type: INCREMENT_PAGE_COUNT
    }
}

export function resetPageCount() {
    return {
        type: RESET_PAGE_COUNT
    }
}

export function applyPagination() {
    /**
     * Wraps calculateChunkedRowKeys so we can feed in current state from other parts of the store, and use Promise.
     *
     * */

    return function (dispatch, getState) {
        return new Promise(function (resolve, reject) {
            const { immutableEditing, mutableSorting } = getState();

            // if we are not in editing mode then technically none of the rows are editable. Let's enforce this.
            let editableRowKeys = [];
            if ( immutableEditing.editingEnabled ) {
                editableRowKeys = immutableEditing.rowKeys;
            }

            dispatch( calculateChunkedRowKeys( mutableSorting.sortedRowKeys, editableRowKeys ) );
            resolve()
        })
        .then(() => dispatch( resetPageCount() ))
        .then(() => dispatch( setAppLoadedPromise() ))
    }
}

function calculateChunkedRowKeys(initialRowKeys, editableRowKeys) {
    return {
        type: CALCULATE_CHUNKED_ROW_KEYS,
        initialRowKeys,
        editableRowKeys
    }
}